let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2dcZB")).then(() => parcelRequire('kn29b'));